import { objectToFormData } from "../../../utils/objectToFormData";
import {
  IWizardConfig,
  SubmitButtonColor,
  WizardMode,
} from "../../wizard/types";
import { UserRole } from "../enums/UserRole";
import { EditProfileForm } from "../userAccount/modals/EditProfile/EditProfileForm";
import { formValidator } from "../userAccount/modals/EditProfile/validators";
import { parseToAccountBackEndModel } from "../userAccount/modals/helpers/parseToAccountBackEndModel";
import useUserQueries from "./useUserQueries";

function addSupport(data, createSupport) {
  const parsedData = objectToFormData(
    parseToAccountBackEndModel(data, UserRole.Support),
  );

  return createSupport(parsedData);
}

export function useAddSupportConfig() {
  const { createSupport } = useUserQueries();

  const getAddSupportConfig = (): IWizardConfig => ({
    steps: [
      {
        width: "568px",
        titleConfig: {
          titleText: "Add Support",
        },
        content: EditProfileForm,
        validator: formValidator(UserRole.Support),
      },
    ],
    submitButtonText: "Save",
    submitButtonColor: SubmitButtonColor.Success,
    saveCallback: (data) => addSupport(data, createSupport),
    mode: WizardMode.Create,
    getInitialData: async () => ({
      role: UserRole.Support,
    }),
  });

  return {
    getAddSupportConfig,
  };
}
